import navigationMenu from '../navigationMenu/reducer';

import locations from './locations';
import metadata from './metadata';
import sitesettings from './sitesettings';
import user from './user';

export const reducers = {
  sitesettings,
  metadata,
  user,
  locations,
  navigationMenu,
};
